import { fetchLocations } from './location_api_util';

// Share public directory data only. Admin screens continue to fetch fresh records.
const cacheDuration = 60 * 1000;
let locations = null;
let loadedAt = 0;
let pending = null;
let checkedBootstrap = false;

export const publicLocationsSnapshot = () => {
  if (!checkedBootstrap && typeof document !== 'undefined') {
    checkedBootstrap = true;
    const bootstrap = document.getElementById('modern-angles-public-locations');
    if (bootstrap) {
      try {
        const data = JSON.parse(bootstrap.textContent);
        if (Array.isArray(data)) { locations = data; loadedAt = Date.now(); }
      } catch (_) { /* Fall back to the API if the bootstrap is unavailable. */ }
    }
  }
  return locations && Date.now() - loadedAt < cacheDuration ? locations : null;
};

export const fetchPublicLocations = () => {
  const snapshot = publicLocationsSnapshot();
  if (snapshot) return Promise.resolve(snapshot);
  if (pending) return pending;
  pending = Promise.resolve(fetchLocations()).then(data => {
    if (!Array.isArray(data)) throw new Error('Invalid service area response');
    locations = data;
    loadedAt = Date.now();
    return data;
  }).finally(() => { pending = null; });
  return pending;
};
